import { toastAnalyticsService } from '../../apis/toastAnalyticsService';

export const fetchSalesRestaurantsApi = async () => {
  const result = await toastAnalyticsService.getRestaurants();
  if (!result.success) {
    throw new Error(result.error || 'Failed to load restaurants');
  }
  return (result.data?.data || []).filter((r) => r.active && !r.archived);
};

export const fetchSalesAnalyticsApi = async ({
  startDate,
  endDate,
  restaurantIds,
  groupBy,
}) => {
  const result = await toastAnalyticsService.getSalesAnalytics({
    startDate,
    endDate,
    restaurantIds,
    groupBy: groupBy ? [groupBy] : undefined,
  });

  if (!result.success) {
    throw new Error(result.error || 'Failed to load sales analytics');
  }

  return result.data?.data || null;
};
